import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { OptionsService } from '@lib/services/options.service';
import { OuiSelectOption } from 'omnium-ui/form-field';
import { AbstractSpecificFieldComponent } from '../abstract-specific-field.component';

@Component({
    selector: 'app-mode-paiement',
    templateUrl: './mode-paiement.component.html',
    styleUrls: ['./mode-paiement.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModePaiementComponent extends AbstractSpecificFieldComponent<string> {
  @Input() override touchNonce?: number;
  override getDataName(): string {
    return 'modePaiement';
  }
  options: OuiSelectOption<string>[];

  constructor(private optionsService: OptionsService) {
    super();
    this.options = this.optionsService.getModePaiementOptions();
  }

  override markAsTouched(): void {
    this.control.markAsTouched();
  }

  override wrapData(value: string): string {
    return value;
  }
}
